import { jsx as _jsx } from "react/jsx-runtime";
import { DataGrid } from "@mui/x-data-grid";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
export const PrimaryGrid = ({ title, paginationModel, onPaginationModelChange, ...dataGridProps }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { t } = useTranslation();
    return (_jsx(Box, { sx: {
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            width: "100%",
            borderRadius: theme.spacing(3),
            px: 2,
            pt: 2,
        }, children: _jsx(DataGrid, { ...dataGridProps, sx: {
                height: isMobile ? 400 : "calc(52dvh - 16px)",
            }, disableColumnFilter: true, disableColumnMenu: true, paginationModel: paginationModel, onPaginationModelChange: onPaginationModelChange, hideFooterSelectedRowCount: true, pageSizeOptions: dataGridProps.pageSizeOptions ?? [5, 10, 25], localeText: {
                footerRowSelected: () => '',
                MuiTablePagination: {
                    labelRowsPerPage: t('admin.dataGrid.rowsPerPage'),
                    labelDisplayedRows: ({ from, to, count }) => `${from}-${to} ${t('admin.dataGrid.of')} ${count}`
                }
            } }) }));
};
